import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 采集实时数据
 */
const measuring = {

  /**
   * 查询所有瞬时数据
   */
  getMeasuringValue (measureId, startTime, endTime, pointCode, pointNumber, sort, limit) {
    return axios.post(base.measuring.getMeasuringValue, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber, sort, limit }))
  },
  /**
   * 查询所有瞬时数据
   */
  getMeasuringValue2 (measures, startTime, endTime, sort, limit) {
    return axios.post(base.measuring.getMeasuringValue2, utils.postParamsArrayToJsonString({ measures, startTime, endTime, sort, limit }))
  },

  /**
   * 查询时瞬时数据
   */
  getMeasuringValueHour (measureId, startTime, endTime, pointCode, pointNumber, limit) {
    return axios.post(base.measuring.getMeasuringValueHour, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber, limit }))
  },
  /**
   * 查询时瞬时数据
   */
  getMeasuringValueDay (measureId, startTime, endTime, pointCode, pointNumber, limit) {
    return axios.post(base.measuring.getMeasuringValueDay, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber, limit }))
  },
  /**
   * 查询时瞬时数据
   */
  getMeasuringValueMonth (measureId, startTime, endTime, pointCode, pointNumber, limit) {
    return axios.post(base.measuring.getMeasuringValueMonth, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber, limit }))
  },
  /**
   * 查询时瞬时数据
   */
  getMeasuringValueYear (measureId, startTime, endTime, pointCode, pointNumber, limit) {
    return axios.post(base.measuring.getMeasuringValueYear, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber, limit }))
  },
  /**
   * 查询时瞬时数据
   */
  getMeasuringValueHour2 (measures, startTime, endTime, limit) {
    return axios.post(base.measuring.getMeasuringValueHour2, utils.postParamsArrayToJsonString({ measures, startTime, endTime, limit }))
  },
  /**
   * 查询时瞬时数据
   */
  getMeasuringValueDay2 (measures, startTime, endTime, limit) {
    return axios.post(base.measuring.getMeasuringValueDay2, utils.postParamsArrayToJsonString({ measures, startTime, endTime, limit }))
  },
  /**
   * 查询时瞬时数据
   */
  getMeasuringValueMonth2 (measures, startTime, endTime, limit) {
    return axios.post(base.measuring.getMeasuringValueMonth2, utils.postParamsArrayToJsonString({ measures, startTime, endTime, limit }))
  },
  /**
   * 查询时瞬时数据
   */
  getMeasuringValueYear2 (measures, startTime, endTime, limit) {
    return axios.post(base.measuring.getMeasuringValueYear2, utils.postParamsArrayToJsonString({ measures, startTime, endTime, limit }))
  },
  /**
   * 查询瞬时数据最大值最小值
   */
  getMeasuringValueMaxMin (measureId, startTime, endTime, pointCode, pointNumber) {
    return axios.post(base.measuring.getMeasuringValueMaxMin, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber }))
  },
  /**
   * 查询瞬时数据最大值最小值
   */
  getMeasuringValueMaxMinHour (measureId, startTime, endTime, pointCode, pointNumber) {
    return axios.post(base.measuring.getMeasuringValueMaxMinHour, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber }))
  },
  /**
   * 查询瞬时数据最大值最小值
   */
  getMeasuringValueMaxMinDay (measureId, startTime, endTime, pointCode, pointNumber) {
    return axios.post(base.measuring.getMeasuringValueMaxMinDay, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber }))
  },
  /**
   * 查询瞬时数据最大值最小值
   */
  getMeasuringValueMaxMinMonth (measureId, startTime, endTime, pointCode, pointNumber) {
    return axios.post(base.measuring.getMeasuringValueMaxMinMonth, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber }))
  },
  /**
   * 查询瞬时数据最大值最小值
   */
  getMeasuringValueMaxMinYear (measureId, startTime, endTime, pointCode, pointNumber) {
    return axios.post(base.measuring.getMeasuringValueMaxMinYear, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber }))
  },
  /**
   * 最新原始值查询
   */
  getLatestMeasuringValue (measureId, pointCode, pointNumber) {
    return axios.post(base.measuring.getLatestMeasuringValue, utils.postParamsArrayToJsonString({ measureId, pointCode, pointNumber }))
  },
  /**
   * 查询所有瞬时数据
   */
  getMeasuringValueAll2 (measures, startTime, endTime, sort, limit) {
    return axios.post(base.measuring.getMeasuringValueAll2, utils.postParamsArrayToJsonString({ measures, startTime, endTime, sort, limit }))
  },
}

export default measuring